const stop = event => {
  event && event.preventDefault();
  event && event.stopPropagation();

  return true;
};

export default stop;
